<template>
<div class="card mb-4 text-center">
    <div class="card-header summary" style="background:black !important; color:white !important">{{range}}</div>
    <div class="card-body py-2" style="font-size:1.1rem;font-weight:500;">
      <span v-if="loading"><i class="fas fa-spinner fa-spin fa-1x"></i></span>
      <div v-else>{{value}}</div>
    </div>
    <div v-if="!loading" class="card-footer dateBg py-1">{{rangeText}}</div>
</div>
</template> 

<script>

export default {
  props: ['site_id','range'],
  data() {
    return {
      rows: [],
      loading: true,
      value: 0,
      rangeText: '',
    };
  },

  created() {
    this.getData();

    Echo.channel("site_" + this.site_id)
      .listen("SiteVisitor", () => {
        this.getData();
      });
  },

    methods: {
        getData() {

      axios.post(`/websites/summary`, {
        site_id: this.site_id,
        range: this.range,
      }).
      then((response) => {
        this.value = response.data.value;
        this.rangeText = response.data.rangeText;
      }).catch((error) => {
        console.sweetfire(error.response.data.message);
      }).finally(() => {
        this.loading = false;
      });

    },
    }

}
</script>

<style scoped>
.card-header.summary {
    padding: 0.2rem 1.5rem !important;
    font-weight: 300 !important;
    font-size: 0.80rem;
}
.dateBg {
  font-size:0.8rem;
  /* background:#36a2ea; */
  background:#000;
  color:#fff;
  border-top:none;
  font-weight:300;
}
</style>